import * as API from '@/api/pickFaultApi';
import utils from '@/utils/utils';

const state = {
  opinions: [], // 意见列表
  opinionTotal: 0, // 意见总数
  userInfo: {
    headUrl:require('../assets/pickFault/default_avatar.png')
  }, // 用户信息
  score: 0, // 积分
  rankList: [], // 排名列表
  rankTotal: 0, // 排名总数
  rank: 0,// 排名
}

const actions = {

}

const mutations = {
  async queryOpinion(state, param) {
    try{
      const resp = await API.queryOpinion(param);
      const { returnCode, message, resultData } = resp.data;
      if (returnCode === '000000'){
        const { records, total, userInfo, score  } = resultData;
        state.opinions = state.opinions.concat(records);
        state.opinionTotal = total;
        state.userInfo = Object.assign({}, userInfo);
        state.score = score;
      } else {
        utils.popMessage(message);
      }
    } catch(err) {
      console.log(err);
    }
  },
  async queryRankList(state, param) {
    try{
      const resp = await API.queryRankList(param);
      const { returnCode, message, resultData } = resp.data;
      if (returnCode === '000000'){
        const { resultList, userInfo, rank, total, myScore } = resultData;
        state.rankList = state.rankList.concat(resultList);
        state.rankTotal = total;
        state.userInfo = Object.assign({}, userInfo);
        state.rank = rank;
        state.score = myScore;
      } else {
        utils.popMessage(message);
      }
    } catch(err) {
      console.log(err);
    }
  },
  clearOpinion(state){
    state.opinions = [];
  },
  clearRank(state) {
    state.rankList = [];
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}


// WEBPACK FOOTER //
// ./src/store/pickFault.js